import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Typography from '../../Generic/Typography';
import { Button } from '../../Generic/Button';
import cardStyles from './RelatedArticles-tw-styles';
import { getCdnImage as getImageUrl } from '../../../utils/ImageManager';
import getWidth from '../../../utils/gridWidth';
import { withLocale } from '../../Generic/LocaleProvider';
import globalConstants from '../../../constants/global';
import path from '../../../assets/images/svgImages.svg';
import i18nMessages from '../../../constants/messages/pt-BR';
import { CardMedia, Card, CardContent } from '../../Generic/Card';

const urlJson = require('../../../data/pt-BR/url.json');

export class RelatedArticles extends React.PureComponent {
  render() {
    const { data, locale } = this.props;
    const constants = require(`../../../constants/messages/${locale}`);
    let cardType = constants.relatedArticles;
    let cardTypestyle =
      (data && data.styles && data.styles.trim()) ||
      cardType ||
      i18nMessages.relatedArticles;
    if (cardStyles[cardTypestyle] === undefined) {
      cardTypestyle = cardType;
    }
    let styles = cardStyles[cardTypestyle];
    const mediaProps = {
      type: i18nMessages.img,
      src: data.heroImage && data.heroImage.url,
      alt: data.heroImage && data.heroImage.altText,
      sizes: data.heroImage && data.heroImage.sizes,
    };
    let mainWrapper = {
      generic: styles.card.mainWrapper.generic,
      notLastChild: styles.card.mainWrapper.notLastChild,
      lastChild: styles.card.mainWrapper.lastChild,
    };
    let widthClass;
    if (data.componentWidth == null) {
      widthClass = '';
    } else {
      widthClass = getWidth(data.componentWidth);
    }
    let product_url = data.slug
      ? urlJson?.[globalConstants.contentType.articlePage]?.[data.slug]?.path || ''
      : '';
    let cardMedia = '';
    if (mediaProps.src) {
      cardMedia = (
        <CardMedia
          className={classNames(styles.card.media)}
          image={getImageUrl(mediaProps.src)}
          component={mediaProps.type}
          sizes={mediaProps.sizes}
          alt={mediaProps.alt ? mediaProps.alt : 'img'}
          cardType={cardType}
        />
      );
    }

    let cardMediaLink = '';
    if (product_url) {
      cardMediaLink = (
        <a
          data-pgaction-redirection="0"
          href={product_url}
          className={classNames([data.gaEventClass])}
          title={data.callToActions && data.callToActions[0].tooltip}
        >
          {cardMedia}
        </a>
      );
    } else {
      cardMediaLink = cardMedia;
    }
    let title = '';
    if (data.title) {
      title = (
        <Typography component="h3" className={styles.card.title}>
          {data.title}
        </Typography>
      );
    }
    return (
      <Card
        key={data.id}
        className={classNames(
          widthClass,
          mainWrapper.generic,
          mainWrapper.notLastChildNew,
          mainWrapper.lastChild
        )}
      >
        <div className={classNames(cardStyles[cardTypestyle].mediaWrapper)}>
          {cardMediaLink}
          <CardContent className={classNames(styles.card.content)}>
            <div className={classNames(styles.card.titleWrapper)}>
              <Button
                to={product_url}
                className={classNames(styles.card.header)}
                aria-label="Artigo da Pantene sobre cuidados com o cabelo"
              >
                {title}
              </Button>
            </div>
          </CardContent>
        </div>
      </Card>
    );
  }
}

RelatedArticles.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
  locale: PropTypes.string.isRequired,
};

export default withLocale(RelatedArticles);
